'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = require('../events');

var _traits = require('../traits');

var _getUserPackage = require('../utils/cookie/getUserPackage');

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    event: _events.EVENT_LOG_IN,
    validateProps: function validateProps() {
        var _ref;

        return _ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_EMAIL, _propTypes2.default.string.isRequired), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PACKAGE, _propTypes2.default.string), _ref;
    },
    traitsToProps: function traitsToProps(traits) {
        var _ref2;

        return _ref2 = {}, (0, _defineProperty3.default)(_ref2, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_ref2, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()), _ref2;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/events/logIn.js
// module id = 2056
// module chunks = 1